<template>
<div :class="$style.wrapper">
  <el-row type="flex" justify="space-around" v-for="shapeType in shapeTypeList" :key="shapeType.index" :class="$style.row">
    <drag :transfer-data="transferData(shapeData)" v-for="shapeData in shapeType" :key="shapeData.index">
      <w-map-button :icon="shapeData.icon"></w-map-button>
    </drag>
  </el-row>
</div>
</template>

<script>
import WMapButton from '@/views/topologymap/components/MapButton';
import { Drag } from 'vue-drag-drop';
import { Q } from '@/views/topologymap/js/maps';

export default {
  name: 'WShapeElement',
  components: {
    WMapButton,
    Drag,
  },
  data() {
    return {
      shapeTypeList: [
        [
          {
            value: 'circle',
            icon: 'map-objectshape-oval',
            type: 'oval',
          },
          {
            value: 'rectangle',
            icon: 'map-objectshape-rect',
            type: 'rect',
          },
        ],
        [
          {
            value: 'roundrect',
            icon: 'map-objectshape-roundrect',
            type: 'roundrect',
          },
          {
            value: 'triangle',
            icon: 'map-objectshape-triangle',
            type: 'triangle',
          },
        ],
        [
          {
            value: 'pentagon',
            icon: 'map-objectshape-pentagon',
            type: 'pentagon',
          },
          {
            value: 'hexagon',
            icon: 'map-objectshape-hexagon',
            type: 'hexagon',
          },
        ],
        [
          {
            value: 'diamond',
            icon: 'map-objectshape-diamond',
            type: 'diamond',
          },
          {
            value: 'parallelogram',
            icon: 'map-objectshape-parallelogram',
            type: 'parallelogram',
          },
        ],
        [
          {
            value: 'rhombus',
            icon: 'map-objectshape-rhombus',
            type: 'rhombus',
          },
          {
            value: 'trapezium',
            icon: 'map-objectshape-trapezium',
            type: 'trapezium',
          },
        ],
        [
          {
            value: 'cross',
            icon: 'map-objectshape-cross',
            type: 'cross',
          },
          {
            value: 'star',
            icon: 'map-objectshape-star',
            type: 'star',
          },
        ],
        [
          {
            value: 'arrow1',
            icon: 'map-objectshape-arrow1',
            type: 'arrow.1',
          },
          {
            value: 'arrow2',
            icon: 'map-objectshape-arrow2',
            type: 'arrow.2',
          },
        ],
        [
          {
            value: 'arrow3',
            icon: 'map-objectshape-arrow3',
            type: 'arrow.3',
          },
          {
            value: 'heart',
            icon: 'map-objectshape-heart',
            type: 'heart',
          },
        ],
        [
          {
            value: 'text',
            icon: 'map-objectshape-text',
            type: 'text',
          },
          {
            value: 'lan',
            icon: 'map-objectshape-lan',
            type: 'lan',
          },
        ],
      ],
    };
  },
  methods: {
    transferData(shapeData) {
      let modelType = Q.ShapeModel;
      if (shapeData.type === 'lan') {
        modelType = Q.VirtualLanModel;
      } else if (shapeData.type === 'text') {
        modelType = Q.LabelModel;
      }
      return {
        type: modelType,
        data: [
          {
            shapeType: shapeData.type,
          },
        ],
      };
    },
  },
};
</script>

<style module>
.wrapper {
  padding-top: 10px;
}
.row {
  height: calc(100% / 9);
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/element/ShapeElement.vue